import React, { Component } from 'react'
import { Container, Row, Col, Card, CardBody } from 'reactstrap'
import RentalsList from './RentalsList'
import { debounce } from 'lodash'
import "./Rentals.css"
import RentalsListHeader from "./RentalsListHeader"
import ListingTabs from '../../Material/ListingTabs'
import ReportsPanel from '../../Reports/ReportsPanel'
import { buildPresets } from '../../Filters/presetFilters'
import { ROUTES } from '../../Layout/routes'
import { withPathTab } from '../../Functions/usePathTab'

import withApolloClient from '../../withApolloClient'

// The page's one default filter, expressed as an Advanced Filters preset --
// the same FilterInput shape the query already sends for user filters, so the
// popover, the chips and the query all read one source of truth. Editable:
// users could change the Rental Stage before, so they still can.
// "10" is the raw model value -- NOT the graphene enum name "A_10".
const RENTAL_STAGE_PRESET = [
    { fieldName: "stage", filterType: "equal", filterValues: "10", editable: true },
]

export const RENTALS_LISTING_TABS = [
    { id: "all", name: "All Rentals" },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
]

class RentalsListContainer extends Component {
    constructor(props) {
        super(props)
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the declared set and is
        // what Reset returns to.
        const initialPresets = buildPresets(RENTAL_STAGE_PRESET)
        this.state = {
            filterValues: {
                orderBy: ["-start_date", "-driver__in_office"],
            },
            presets: initialPresets,
            defaultPresets: initialPresets,
            selectedDrivers: [],
        }
    }
    setPresets = (presets) => this.setState({ presets })
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (value === "false") {
            value = false
        } else {
            value = true
        }
        this.setState({ [name]: value })
    };
    updateSelection = (selection) => {
        if (Array.isArray(selection)) {
            this.setState({ selectedDrivers: selection })
        } else {
            if (this.state.selectedDrivers.includes(selection))
                this.setState({ selectedDrivers: this.state.selectedDrivers.filter(item => item != selection) })
            else
                this.setState({ selectedDrivers: [...this.state.selectedDrivers, selection] })
        }
    }
    updateSearchTerm = debounce((searchTerm) => {
        this.setState({ searchTerm: searchTerm })
    }, 500)

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    render() {
        return (
            <Container fluid className="rental-list-container">
                <ListingTabs
                    tabs={RENTALS_LISTING_TABS}
                    activeTab={this.props.activeTabId}
                    onChange={this.props.changeTab}
                />
                {this.props.activeTabId !== "reports" && <RentalsListHeader
                    activeTab="All Rentals"
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                    selectedDrivers={this.state.selectedDrivers} history={this.props.navigate} location={this.props.location}
                    resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                />}
                <Row>
                    <Col>
                        {this.props.activeTabId === "reports" ?
                            <ReportsPanel reportId="agreements" />
                            :
                            <RentalsList
                                updateOrder={this.updateOrder}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                presets={this.state.presets}
                                selectedDrivers={this.state.selectedDrivers}
                                updateDriversSelection={this.updateSelection}
                            />}
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withPathTab(ROUTES.rentals)(withApolloClient(RentalsListContainer))

